import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import Icon from '../Icon';

const StyledIcon = styled(Icon)`
  fill: none;
`;

const NotifiedMe = (props) => {
  const { color, ...rest } = props;
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <StyledIcon width="25" height="24" viewBox="0 0 25 24" {...rest}>
      <path
        d="M10.009 18.0024V18.5147C10.009 19.8893 11.1234 21.0037 12.4981 21.0037H12.5001C13.1605 21.004 13.7939 20.7419 14.2611 20.2751C14.7282 19.8083 14.9908 19.1751 14.9911 18.5147V18.0024"
        stroke="#3C4852"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.4494 18.0025C19.5837 18.0025 20.5032 17.0829 20.5032 15.9486C20.5028 15.3724 20.274 14.8198 19.867 14.412L18.5024 13.0484V8.99872C18.5024 5.68363 15.815 2.99622 12.4999 2.99622C9.18483 2.99622 6.49742 5.68363 6.49742 8.99872V13.0484L5.13285 14.412C4.72583 14.8198 4.49704 15.3724 4.49658 15.9486C4.49658 16.4933 4.71297 17.0157 5.09814 17.4009C5.48331 17.7861 6.00572 18.0025 6.55044 18.0025H18.4494Z"
        fill="#3C4852"
        stroke="#3C4852"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.3342 10.2076L12.0428 12.5003L10.666 11.1247"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </StyledIcon>
  );
};

NotifiedMe.propTypes = {
  color: PropTypes.string
};

NotifiedMe.defaultProps = {
  color: 'var(--color-text-primary)'
};

export default NotifiedMe;
